import { activityTypes as activityTypesDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type ActivityTypes = {
    value: string;
    label: string;
};

type Props = {}

export const activityTypes = ({}: Props): ActivityTypes[] =>
    activityTypesDiagram();
